module.exports = __webpack_public_path__ + "assets/img/1-m.9b6a8b99.jpg";